// extracted by mini-css-extract-plugin
export var shopDealsButton = "DescriptionTabs-module--shopDealsButton--1a354";
export var tabListGroup = "DescriptionTabs-module--tabListGroup--f6b49";
export var tabListWrapper = "DescriptionTabs-module--tabListWrapper--02c29";